import { createSlice } from "@reduxjs/toolkit";

const initialDetailsState = {
    detailsTabs: 0,
    notesType: null,
    isVerticalListOpened: false,
    drawerHasOpened: false,
}

const detailsSlice = createSlice({
    name: 'details',
    initialState: initialDetailsState,
    reducers: {
        setActiveTab(state, data) {
            state.detailsTabs = data.payload
        },
        resetActiveTab(state) {
            state.detailsTabs = 0
        },
        setNotesType(state, data) {
            state.notesType = data.payload
        },
        setIsVerticalListOpened(state, data) {
            state.isVerticalListOpened = data.payload
        },
        setDrawerHasOpened(state, data) {
            state.drawerHasOpened = data.payload
        }
    }
})

export const detailsActions = detailsSlice.actions

export default detailsSlice.reducer